import { InfoBubblesMini } from "./InfoBubblesMini";
import { InfoBubblesNormal } from "./InfoBubblesNormal";
import { InfoBubblesProps } from "./InfoBubblesTypes.ts";

export const InfoBubbles = (props: InfoBubblesProps) => {
  const { variant = "default" } = props;

  if (variant === "mini") {
    return <InfoBubblesMini {...props} />;
  }

  return <InfoBubblesNormal {...props} />;
};
